var _style, _polyline, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "171.7,621.7 20,18.4 620,186.9 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 245.8,
    y1: 362.4,
    x2: 283.7,
    y2: 513.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 395.5,
    y1: 404.8,
    x2: 245.8,
    y2: 362.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 283.7,
    y1: 513.3,
    x2: 395.5,
    y2: 404.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,470.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 283.7,
    y1: 513.3,
    x2: 134,
    y2: 470.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,470.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "134,470.9 171.9,621.9 283.7,513.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 134,
    y1: 470.9,
    x2: 245.8,
    y2: 362.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 245.8,
    y1: 362.4,
    x2: 357.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 357.7,
    y1: 253.8,
    x2: 469.5,
    y2: 145.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 319.8,
    y1: 102.9,
    x2: 357.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 357.7,
    y1: 253.8,
    x2: 207.9,
    y2: 211.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 207.9,
    y1: 211.5,
    x2: 245.8,
    y2: 362.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 245.8,
    y1: 362.4,
    x2: 96.1,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 96.1,
    y1: 320,
    x2: 134,
    y2: 470.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 58.2,
    y1: 169.1,
    x2: 96.1,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 207.9,
    y1: 211.5,
    x2: 58.2,
    y2: 169.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 96.1,
    y1: 320,
    x2: 207.9,
    y2: 211.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 207.9,
    y1: 211.4,
    x2: 319.8,
    y2: 102.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 319.8,
    y1: 102.9,
    x2: 170,
    y2: 60.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 170,
    y1: 60.5,
    x2: 207.9,
    y2: 211.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "58.2,169.1 20.3,18.1 170,60.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 58.2,
    y1: 169.1,
    x2: 170,
    y2: 60.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "507.4,296.2 619.2,187.7 469.5,145.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 469.5,
    y1: 145.3,
    x2: 507.4,
    y2: 296.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 507.4,
    y1: 296.2,
    x2: 357.7,
    y2: 253.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 357.7,
    y1: 253.8,
    x2: 395.5,
    y2: 404.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 395.5,
    y1: 404.8,
    x2: 507.4,
    y2: 296.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 469.5,
    y1: 145.3,
    x2: 319.8,
    y2: 102.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejs);
export default __webpack_public_path__ + "static/media/threejs.34faec932f70929fc2778eaf26de073c.svg";
export { ForwardRef as ReactComponent };